<template>
	<li :class="[item.IsActive ? 'active' : '', item.CustomClass]">
		<a v-bind:href="item.Url">{{ item.Label }}</a>

		<ul v-if="item.HasChildren" class="side-menu-submenu">
			<menu-item v-for="(item, index) in item.Children" v-bind:item="item" v-bind:key="index"></menu-item>
		</ul>
	</li>
</template>

<script>
	import MenuItem from './menu-item';

	export default {
		props: ['item'],
		beforeCreate: function () {
			this.$options.components.MenuItem = require('./menu-item.vue').default;
		},
		mounted: function () {

		},
		methods: {

        },
    }
</script>